import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { i18n } from 'config/locales';
import { formTypes } from 'config/formTypes';
import { ErrorList } from 'components/ErrorList';
import SectionNavigation from 'components/Section/shared/SectionNavigation';
import { SUBSTANCE_USE } from 'constants/sections';
import { rootSelectors } from '@redux/modules/selectors';
import Intro from './Intro';
import Review from './Review';
import NegativeImpacts from './Alcohol/NegativeImpacts';
import OrderedCounselings from './Alcohol/OrderedCounselings';
import VoluntaryCounselings from './Alcohol/VoluntaryCounselings';
import ReceivedCounselings from './Alcohol/ReceivedCounselings';
import DrugUses from './Drugs/DrugUses';
import DrugInvolvements from './Drugs/DrugInvolvements';
import DrugClearanceUses from './Drugs/DrugClearanceUses';
import DrugPublicSafetyUses from './Drugs/DrugPublicSafetyUses';
import PrescriptionUses from './Drugs/PrescriptionUses';
import DrugNegativeImpact from './Drugs/DrugNegativeImpact';
import ThcActivityIntro from './Thc/ThcActivityIntro';
import ThcClearanceUses from './Thc/ThcClearanceUses';
import ThcInvolvements from './Thc/ThcInvolvements';
import ThcPublicSafetyUses from './Thc/ThcPublicSafetyUses';
import ThcUses from './Thc/ThcUses';
import OrderedTreatments from './Drugs/OrderedTreatments';
import VoluntaryTreatments from './Drugs/VoluntaryTreatments';
import DrugSupplementalUses from './Drugs/DrugSupplementalUses';
import DrugActivityIntro from './Drugs/DrugActivityIntro';
import DrugSupplementalPublicSafetyUses from './Drugs/DrugSupplementalPublicSafetyUses';
import SectionNotFound from '../shared/SectionNotFound';
import AlcoholSupplemental from './Alcohol/AlcoholSupplemental';
import AlcoholIntro from './Alcohol/Intro';

const SubstanceUse = function ({
  isReview, subsection, location, formType
}) {
  const subsectionLibrary = {
    intro: Intro,
    'drugs/intro': DrugActivityIntro,
    'drugs/usage': DrugUses,
    'drugs/purchase': DrugInvolvements,
    'drugs/clearance': DrugClearanceUses,
    'drugs/publicsafety': DrugPublicSafetyUses,
    'drugs/misuse': PrescriptionUses,
    'drugs/negativeimpact': DrugNegativeImpact,
    'drugs/ordered': OrderedTreatments,
    'drugs/voluntary': VoluntaryTreatments,
    'drugs/supplementalusage': DrugSupplementalUses,
    'drugs/supplementalpublicsafety': DrugSupplementalPublicSafetyUses,
    'alcohol/intro': AlcoholIntro,
    'alcohol/negative': NegativeImpacts,
    'alcohol/ordered': OrderedCounselings,
    'alcohol/voluntary': VoluntaryCounselings,
    'alcohol/additional': ReceivedCounselings,
    'alcohol/supplemental': AlcoholSupplemental,
    'thc/intro': ThcActivityIntro,
    'thc/usage': ThcUses,
    'thc/purchase': ThcInvolvements,
    'thc/clearance': ThcClearanceUses,
    'thc/publicsafety': ThcPublicSafetyUses,
    review: Review,
  };
  const form = formTypes[formType];
  const section = form.find((s) => s.key === SUBSTANCE_USE);
  const flattenedSections = formTypes.reduceSubsections([section]);
  const subsectionClasses = `view view-${subsection.name || 'unknown'}`;
  const title = isReview && i18n.t('review.title');
  const para = isReview && i18n.m('review.para');

  return (
    <div className="section-view">
      {title && <h1 className="title">{title}</h1>}
      {para}
      <div className={subsectionClasses}>
        {isReview && (
          <div className="top-btns">
            <ErrorList />
          </div>
        )}

        <Switch>
          {flattenedSections.map((sub) => (
            <Route key={sub.key} path={sub.fullPath} component={subsectionLibrary[sub.name]} />
          ))}
          <Route component={SectionNotFound} />
        </Switch>

        <SectionNavigation currentPath={location.pathname} />
      </div>
    </div>
  );
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  subsection: state.section.subsection,
  isReview: rootSelectors.section.getIsSectionInReview(state),
  formType: rootSelectors.application.getFormType(state),
});

SubstanceUse.propTypes = {
  subsection: PropTypes.object,
  isReview: PropTypes.bool,
  location: PropTypes.object,
  formType: PropTypes.string.isRequired,
};

SubstanceUse.defaultProps = {
  subsection: {},
  location: {},
};

export var SubstanceUseSections = function () {
  return <Review />;
};

export default connect(mapStateToProps)(SubstanceUse);
